export const blockIconsNavigationArrowBackiOSNew = (
	<span className='material-symbols-outlined'>arrow_back_ios_new</span>
);
